import { BarChart3, FileText, Repeat, Wallet } from "lucide-react";

const ITENS = [
  { icone: BarChart3, titulo: "Visão do mês", texto: "Faturamento, custo da produção, margem e resultado, com gráficos e DRE gerencial." },
  { icone: Wallet, titulo: "A receber e a pagar", texto: "O extrato de cada cliente sai sozinho dos pedidos concluídos." },
  { icone: Repeat, titulo: "Custos fixos", texto: "Aluguel, salários e sistemas lançados uma vez, previstos todo mês." },
  { icone: FileText, titulo: "Notas fiscais", texto: "Registre as notas e guarde o PDF e o XML junto do lançamento." },
];

/** O que o financeiro faz, para quem ainda não tem o plano pago. */
export function PlanoPagoFinanceiro() {
  return (
    <div className="rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm sm:p-8 dark:border-border dark:bg-card">
      <span className="rounded-full bg-brand-50 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-brand-700 dark:bg-primary/10 dark:text-primary">
        Plano pago
      </span>
      <h2 className="mt-3 text-lg font-bold text-zinc-900 dark:text-foreground">O financeiro do laboratório, sem planilha</h2>
      <p className="mt-1 max-w-2xl text-sm text-zinc-500 dark:text-muted-foreground">
        Tudo o que o laboratório já registra (pedidos concluídos, consumo de material e compras) vira
        receita, custo e margem, sem digitar de novo.
      </p>
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {ITENS.map((i) => (
          <div key={i.titulo} className="flex gap-3 rounded-xl border border-zinc-200 p-4 dark:border-border">
            <i.icone className="mt-0.5 h-5 w-5 shrink-0 text-brand-600 dark:text-primary" />
            <div>
              <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">{i.titulo}</p>
              <p className="text-xs text-zinc-500 dark:text-muted-foreground">{i.texto}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-6 text-xs text-zinc-500 dark:text-muted-foreground">Fale com a equipe do DentalBook para liberar o plano pago.</p>
    </div>
  );
}
